<template>
    <van-nav-bar title="关于校园订餐" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>
  <van-cell-group inset style="margin-top: 40px">
    <van-cell
      title="关于"
      size="large"
      label="本平台由山东眯去来网络科技有限公司提供相关服务,
    在使用过程遇到任何问题请联系我们,我们的客服热线是:400-6622205 服务时间: 8:30 - 17:30"
    />
  </van-cell-group>
</template>

<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { Cell, CellGroup } from "vant";

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  setup() {
    const router = useRouter(); //传值
    const toAbout = () => {
      router.replace("/");
    };
    const onLogout = () => {
      localStorage.clear();
      router.replace("/");
    };

    const toResetPwd = () => {
      router.push({
        path: "/resetpwd",
      });
    };
    const onClickLeft = () => {
      router.go(-1);
    };
    onMounted(() => {
      /* eslint-disable */
      // payType.value = Route.query.payType;
      // onLoad();
    });
    return {
      onLogout,
      toResetPwd,
      toAbout,
      onClickLeft
    };
  },
};
</script>

<style lang="less"></style>
>
